/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const AlertType = {
  info: 'info',
  warning: 'warning',
  danger: 'danger',
  success: 'success',
  collapsible: 'collapsible',
};

export function InlineAlert(props) {
  return (
    <div className={classNames('alert-spacing', props.className)}>
      <div className={classNames('alert', `alert-${props.type}`)}>
        <div className="alert-image" />
        <div className="alert-content">
          {props.children}
        </div>
      </div>
    </div>
  );
}

InlineAlert.propTypes = {
  type: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

InlineAlert.defaultProps = {
  className: undefined,
};

export function InlineInfoAlert(props) {
  return (
    <InlineAlert {...props} type={AlertType.info} />
  );
}

export function InlineWarningAlert(props) {
  return (
    <InlineAlert {...props} type={AlertType.warning} />
  );
}

export function InlineDangerAlert(props) {
  return (
    <InlineAlert {...props} type={AlertType.danger} />
  );
}

export function InlineSuccessAlert(props) {
  return (
    <InlineAlert {...props} type={AlertType.success} />
  );
}

export class InlineCollapsibleAlert extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isCollapsed: props.isCollapsed };
  }
  onCollapseLinkClick = () => this.setState({ isCollapsed: !this.state.isCollapsed }, () => this.props.collapseCallback());
  onDismissLinkClick = () => this.props.dismissCallback();
  render() {
    const {
      dismissLinkText, children,
    } = this.props;
    return (
      <InlineAlert type={AlertType.collapsible}>
        <div
          role="link"
          className="collapsible-link"
          onClick={this.onCollapseLinkClick}
          onKeyPress={this.onCollapseLinkClick}
        >
          <div className={this.state.isCollapsed ? 'expanderImage' : 'expandedImage'} />
          {children}
        </div>
        {dismissLinkText &&
          <a
            className="dismiss-link"
            onClick={this.onDismissLinkClick}
            onKeyPress={this.onDismissLinkClick}
            aria-label="dismiss-link"
            aria-labelledby="dismiss-link"
            href="javascript:void(0);" // eslint-disable-line no-script-url
          >
            {dismissLinkText}
          </a>}
      </InlineAlert>
    );
  }
}

const InlineAlertProps = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  className: PropTypes.string,
};

const InlineAlertDefaultProps = {
  className: undefined,
};

InlineInfoAlert.propTypes = InlineAlertProps;
InlineInfoAlert.defaultProps = InlineAlertDefaultProps;
InlineWarningAlert.propTypes = InlineAlertProps;
InlineWarningAlert.defaultProps = InlineAlertDefaultProps;
InlineDangerAlert.propTypes = InlineAlertProps;
InlineDangerAlert.defaultProps = InlineAlertDefaultProps;
InlineSuccessAlert.propTypes = InlineAlertProps;
InlineSuccessAlert.defaultProps = InlineAlertDefaultProps;


InlineCollapsibleAlert.defaultProps = {
  isCollapsed: false,
  collapseCallback: _.noop,
  dismissLinkText: '',
  dismissCallback: _.noop,
};
InlineCollapsibleAlert.propTypes = {
  isCollapsed: PropTypes.bool,
  collapseCallback: PropTypes.func,
  dismissLinkText: PropTypes.string,
  dismissCallback: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
